<div class="action-buttons d-flex align-items-center justify-content-end me-2">
    <button
        *ngFor="let button of nonDropdownButtons"
        (click)="button.handler(item)"
        type="button"
        class="btn"
        [ngClass]="{
            'btn-primary': button.isPrimary && !button.showIconOnly,
            'btn-secondary': button.isSecondary && !button.showIconOnly,
            'ca-btn-icon': button.showIconOnly,
        }"
        [disabled]="button.isDisabled"
        [attr.data-uit]="button.uitAttribute + '-btn'"
    >
        <ca-icon *ngIf="button.icon" [name]="button.icon" size="s"></ca-icon>
        <span *ngIf="button.label && !button.showIconOnly">{{ button.label }}</span>
    </button>
    <ca-dropdown-submenu data-uit="workflow-results-submenu" *ngIf="dropdownButtons.length > 0">
        <button
            *ngFor="let dropdownButton of dropdownButtons"
            type="button"
            class="dropdown-item"
            (click)="dropdownButton.handler(item)"
            [title]="dropdownButton.showIconOnly && dropdownButton.label"
        >
            <ca-icon *ngIf="dropdownButton.icon" [name]="dropdownButton.icon" size="s"></ca-icon>
            <span *ngIf="!dropdownButton.showIconOnly">{{ dropdownButton.label }}</span>
        </button>
    </ca-dropdown-submenu>
</div>
